import React from "react";
import MasterdataIndexlinks from "./indexLinks";
import axios from "axios";
import FormErrorHandler from "../../components/FormErrorHandler";
import { scrollToElem } from "../../functions.js";

export default class masterdataMeasurementBundlesForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            name: "",
            order: 1,
            measurements: [],
            measurementValues: [],
            is_active: 0
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateElementState = this.updateElementState.bind(this);
    }

    updateElementState(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        let postData = {
            name: this.state.name,
            order: this.state.order,
            is_active: this.state.is_active
        };

        if (this.state.editMode) {
            axios
                .patch("/v1/measurementbundles/" + this.props.params.itemID + "/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De toetsbundel '${response.data.name}' is succesvol opgeslagen`,
                        link: `/masterdata/measurementbundles/edit/${this.props.params.itemID}`
                    });
                    this.props.router.push("/masterdata/measurementbundles");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            axios
                .post("/v1/measurementbundles/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De toetsbundel '${response.data.name}' is succesvol opgeslagen`,
                        link: `/masterdata/measurementbundles/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/masterdata/measurementbundles");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    }

    componentDidMount() {
        if (this.state.editMode) {
            axios
                .get("/v1/measurementbundles/" + this.props.params.itemID + "/")
                .then((response) => {
                    this.setState({
                        name: response.data.name,
                        is_active: response.data.is_active ? 1 : 0,
                        order: response.data.order,
                        measurements: response.data.measurements
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

            axios
                .get("/v1/measurements/?fields=uuid,name&pagination=false")
                .then((response) => {
                    this.setState({
                        measurementValues: response.data
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    render() {
        let measurements = [];
        if (this.state.measurementValues.length > 0) {
            this.state.measurements.forEach((measurement) => {
                let m = this.state.measurementValues.find((meas) => meas.uuid == measurement);
                measurements.push(<li key={measurement}>{m.name}</li>);
            });
        }
        if (measurements.length > 0) {
            measurements = (
                <div>
                    <label>De volgende zijn gekoppeld aan deze toetsbundel</label>
                    <ol>{measurements}</ol>
                </div>
            );
        }

        return (
            <div>
                <MasterdataIndexlinks />

                <div>
                    <form onSubmit={this.handleSubmit} ref="formref">
                        <div className="container">
                            <h2>Toetsbundel {this.state.editMode ? "bewerken" : "toevoegen"}</h2>

                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Titel *</label>
                                        <input
                                            type="text"
                                            name="name"
                                            ref="name"
                                            autoFocus={true}
                                            onChange={this.updateElementState}
                                            className="form-control form-control-md"
                                            required={true}
                                            value={this.state.name}
                                        />
                                        <FormErrorHandler fieldName="name" errorObject={this.state.errorMessage} />
                                    </div>
                                    <div className="form-group">
                                        <label>Volgorde *</label>
                                        <input
                                            type="number"
                                            name="order"
                                            ref="order"
                                            onChange={this.updateElementState}
                                            className="form-control form-control-md"
                                            required={true}
                                            value={this.state.order}
                                        />
                                        <FormErrorHandler fieldName="order" errorObject={this.state.errorMessage} />
                                    </div>
                                    <div className="form-group">
                                        <label>Actief</label>
                                        <select
                                            className="form-control form-control-md"
                                            name="is_active"
                                            ref="is_active"
                                            onChange={this.updateElementState}
                                            value={this.state.is_active}
                                        >
                                            <option value="1">Ja</option>
                                            <option value="0">Nee</option>
                                        </select>
                                        <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">{measurements}</div>
                                </div>
                            </div>

                            <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                            <div className="form-group">
                                <button className="btn btn-primary" type="submit" tabIndex="50">
                                    Opslaan
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
